import { API } from '@/api';
//import axios from 'axios';

const state = {
  certArray: [],
  key: '',
};

// https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
const getters = {
  getKey: (State) => {
    console.debug('state', state);
    if (state.key) {
      return state.key;
    } else if (typeof window.sessionStorage.getItem('key') === 'string') {
      return JSON.parse(window.sessionStorage.getItem('key') || '{}');
    } else {
      console.error('Error parsing window.sessionStorage.getItem("key")');
      return JSON.parse('{}');
    }
  },
  getCerts: (State) => {
    console.debug('state', state);
    if (Array.isArray(State.certArray) && State.certArray.length > 0) {
      return State.certArray;
    } else if (typeof window.localStorage.getItem('certs') === 'string') {
      return JSON.parse(window.localStorage.getItem('certs') || '[]');
    } else {
      return [];
    }
  },
};
const actions = {
  setCerts({ commit, State }, certArray) {
    commit('setCerts', certArray);
  },
  setKey({ commit, State }, key) {
    commit('setKey', key);
  },
};
const mutations = {
  setKey: (State, key) => {
      State.key = key;
      window.sessionStorage.setItem('key', JSON.stringify(key));
  },
  setCerts: (State, certArray) => {
      const saveCertArray = [];
      const now = new Date();
      for (const cert of certArray) {
        const expired = (cert.expire < now.getTime());
        if (cert.save && !expired) saveCertArray.push(cert);
      }
      State.certArray = saveCertArray;
      window.localStorage.setItem('certs', JSON.stringify(saveCertArray));
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
